import { hasFeature } from 'root/api/admin/features';
import {
  NetworkTestEntity,
  ScoreResults,
} from 'root/apps/NetworkHealthTool/services/NetworkHealthToolService';
import { useNetworkTestService } from 'root/apps/NetworkHealthTool/services/useNetworkHealthToolService';
import { datadogLogs, logError } from 'root/datadog/datadogLogs';

function getCategory(namedEvent: string | undefined): string {
  switch (namedEvent) {
    case 'network_degradation_started':
      return 'network_incident';
    case 'network_recovered':
      return 'network_incident';
    case 'manual_network_test':
      return 'manual_test';
    default:
      return 'network_test';
  }
}

export const report = async (
  scores: ScoreResults,
  test: NetworkTestEntity,
  service: ReturnType<typeof useNetworkTestService>
): Promise<void> => {
  const accountID = window.merchantos.session.getSystemCustomerID();
  const category = getCategory(test.namedEvent);

  try {
    if (await hasFeature('SupportNetworkHealthToolDisplayUiReporting')) {
      await fetch(`/API/V3/Account/${accountID}/EventLog.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          type: 'network',
          category,
          event: test.namedEvent,
        }),
      });
    } else {
      datadogLogs.logger.info('IndexDB Network Health Test Record', {
        type: 'network',
        category,
        event: test.namedEvent,
        log: {
          'Scores: ': scores,
        },
        file: 'NetworkHealthTool.ts',
        source: 'NetworkHealthTool',
      });
    }

    await service.updateNetworkTest(test.id, { syncTimestamp: Date.now() });
  } catch (error) {
    logError(error, {
      message: 'NetworkHealthToolReportingService.report failed',
      source: 'NetworkHealthTool',
      file: 'NetworkHealthTool.ts',
    });
  }
};
